import OfficeExpenseDetails from "../../../../components/company/expense/office-expense/OfficeExpenseDetails";

export default function OfficeExpenseDetailsPage() {
    return <OfficeExpenseDetails/>;
}